<form *ngIf="configForm" [formGroup]="configForm" (ngSubmit)="onSubmit(configForm)">
  <div fxLayout="row" fxLayoutGap="5px">
    <mat-form-field fxFlex="20">
      <input matInput type="number" placeholder="Order" formControlName="order">
    </mat-form-field>
    <mat-form-field fxFlex="20">
      <input matInput type="number" ng-pattern="/^[0-9]{1,3}$/" placeholder="Day offset" formControlName="dayOffset">
    </mat-form-field>
    <mat-form-field fxFlex="30" *ngIf="reminderType == ReminderType.Order">
      <mat-select placeholder="Order template" formControlName="orderEmailTemplateId">
        <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>          
      </mat-select>
    </mat-form-field>
    <mat-form-field fxFlex="30" *ngIf="reminderType == ReminderType.Invoice">
      <mat-select placeholder="Invoice template" formControlName="invoiceEmailTemplateId">
        <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>          
      </mat-select>
    </mat-form-field>
    <div fxFlex="none">
      <button mat-icon-button type="submit" [disabled]="!configForm.valid || configForm.pristine">
        <mat-icon>done</mat-icon>
      </button>
      <button mat-icon-button (click)="delete()" type="button">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>
</form>